import React, { useState } from 'react'

const MushroomEdibility = () => {
  const [mush, setmush] = useState()
  return (
    <div>MushroomEdibility</div>
  )
}

export default MushroomEdibility